import axios from 'axios';
import { API_BASE_URL } from './scanApi';

// Avis publics : moyenne + nombre + répartition + page d'avis (params: page, pageSize, rating).
export const getReviews = (params = {}) => axios.get(`${API_BASE_URL}/reviews`, { params });

// Déposer OU mettre à jour son avis (1 avis par compte scanné).
export const submitReview = (payload) => axios.post(`${API_BASE_URL}/reviews`, payload);

// Récupérer son propre avis existant (pour l'éditer), via son steamId.
export const getMyReview = (steamId) =>
  axios.get(`${API_BASE_URL}/reviews/mine`, { params: { steamId } });
